import { render, staticRenderFns } from "./StepLogistics.vue?vue&type=template&id=3de104a8&scoped=true"
import script from "./StepLogistics.vue?vue&type=script&lang=js"
export * from "./StepLogistics.vue?vue&type=script&lang=js"
import style0 from "./StepLogistics.vue?vue&type=style&index=0&id=3de104a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de104a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3de104a8')) {
      api.createRecord('3de104a8', component.options)
    } else {
      api.reload('3de104a8', component.options)
    }
    module.hot.accept("./StepLogistics.vue?vue&type=template&id=3de104a8&scoped=true", function () {
      api.rerender('3de104a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/components/StepLogistics.vue"
export default component.exports